import _extends from "@babel/runtime/helpers/esm/extends";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _styled from "@emotion/styled-base";
import { compose, space, layout, border, typography, shadow } from 'styled-system';
import PropTypes from 'prop-types';
import propTypes from '@styled-system/prop-types';
import { getStyledFunctionsNames, values } from './utils';
var styledFunctions = {
  space: space,
  layout: layout,
  border: border,
  typography: typography,
  shadow: shadow
};

var Avatar =
/*#__PURE__*/
_styled('img', {
  target: "e1f8ivzw0"
})(compose.apply(void 0, _toConsumableArray(values(styledFunctions))), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9BdmF0YXIuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBY2UiLCJmaWxlIjoiLi4vLi4vc3JjL0F2YXRhci5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7XG4gIGNvbXBvc2UsXG4gIHNwYWNlLFxuICBsYXlvdXQsXG4gIGJvcmRlcixcbiAgdHlwb2dyYXBoeSxcbiAgc2hhZG93LFxufSBmcm9tICdzdHlsZWQtc3lzdGVtJztcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcyc7XG5pbXBvcnQgcHJvcFR5cGVzIGZyb20gJ0BzdHlsZWQtc3lzdGVtL3Byb3AtdHlwZXMnO1xuaW1wb3J0IHsgZ2V0U3R5bGVkRnVuY3Rpb25zTmFtZXMsIHZhbHVlcyB9IGZyb20gJy4vdXRpbHMnO1xuXG5jb25zdCBzdHlsZWRGdW5jdGlvbnMgPSB7IHNwYWNlLCBsYXlvdXQsIGJvcmRlciwgdHlwb2dyYXBoeSwgc2hhZG93IH07XG5jb25zdCBBdmF0YXIgPSBzdHlsZWQoJ2ltZycpKGNvbXBvc2UoLi4udmFsdWVzKHN0eWxlZEZ1bmN0aW9ucykpKTtcblxuQXZhdGFyLmRlZmF1bHRQcm9wcyA9IHtcbiAgYm9yZGVyUmFkaXVzOiAnMTAwJScsXG4gIHNpemU6ICdtZWRpdW0nLFxufTtcblxuQXZhdGFyLnByb3BUeXBlcyA9IHtcbiAgLi4ucHJvcFR5cGVzLnNwYWNlLFxuICAuLi5wcm9wVHlwZXMubGF5b3V0LFxuICAuLi5wcm9wVHlwZXMuYm9yZGVyLFxuICAuLi5wcm9wVHlwZXMudHlwb2dyYXBoeSxcbiAgLi4ucHJvcFR5cGVzLnNoYWRvdyxcbiAgYWx0OiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG59O1xuXG5BdmF0YXIuc3R5bGVkRnVuY3Rpb25zID0gZ2V0U3R5bGVkRnVuY3Rpb25zTmFtZXMoc3R5bGVkRnVuY3Rpb25zKTtcblxuZXhwb3J0IGRlZmF1bHQgQXZhdGFyO1xuIl19 */");

Avatar.defaultProps = {
  borderRadius: '100%',
  size: 'medium'
};
Avatar.propTypes = _extends({}, propTypes.space, {}, propTypes.layout, {}, propTypes.border, {}, propTypes.typography, {}, propTypes.shadow, {
  alt: PropTypes.string.isRequired
});
Avatar.styledFunctions = getStyledFunctionsNames(styledFunctions);
export default Avatar;